import { Component } from '@angular/core';

@Component({
    selector: 'app-location-card',
    templateUrl: './location-card.component.html',
    styleUrl: './location-card.component.scss',
    standalone: true
})
export class LocationCardComponent {

}
